<template>
  <div
    class="navbar"
      :style="{
            background: `${colors.primary}`,
            color: colors.theme == 'dark' ? `#fff` : `#000`,
        }"
  >
    <div
      class="navbar_content"
      :style="{
            background: `${colors.primary}`,
            color: colors.theme == 'dark' ? `#fff` : `#000`,
        }"
    >
      <div class="logo-container">
        <div class="logo">
          <img :src="colors.clientLogoPath" alt="Logo Cliente" v-if="colors.clientLogoPath">
          <RepenseLogo v-else></RepenseLogo>
        </div>
      </div>
      <div class="help-container">
        <a class="help-content" href="https://huddlebrasil.zendesk.com/hc/pt-br/articles/360051233892-D%C3%BAvidas-Frequentes-Repense-Game-" target="_blank"
        :style='{ color : "#000"}'>
          <span>{{$t("components.navbar.help_button")}}</span>
        </a>
      </div>
      <div class="score-container">
        <div class="score" v-if="showScore">
          <div class="score_img">
            <Coin></Coin>
          </div>
          <div class="score_value" :style='{
              width: "60%",
              backgroundColor: "#fff",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "28px",
              paddingRight: "10px"
            }'>
            <span :style='{ color : "#000"}'>{{ score.toLocaleString('pt-br') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Bus} from '../../../event-bus.js'
import RepenseLogo from '../customIcons/repenseLogo'
import Coin from '../../shared/customIcons/Coin'
    export default{
        components: {RepenseLogo, Coin},
        props : {
            currentScore : {
                type : Number
            },
            showScore : {
                type : Boolean,
                default : true
            }
        },

        data: function(){
            return{
                score: this.$store.getters.getGameData('currentScore'),
                title : ''
            }
        },
        created(){
          this.$store.commit("resetTimeDiscount");
            Bus.$on('alterScore', this.alterScore)
            this.title = localStorage.getItem('workspaceTitle')
            let gameSetId = localStorage.getItem('gameSetId')
            let self = this
            if(!self.$route.name == 'Rules')
                this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets/${gameSetId}`)
                .then(response => self.$store.commit('setScoreState', response.body.score))
        },
        methods : {
            alterScore(){
                this.score = this.$store.getters.getGameData('currentScore')
            },
            defineLastSolo(soloGames){
                if(soloGames.length < 2) return soloGames[0]
                let lastSolo = soloGames.reduce((a, b) => {
                    return a.createdAt > b.createdAt ? a : b
                })
                return lastSolo
            }
        },
    
  

  data: function() {
    return {
      score: this.$store.getters.getGameData("currentScore"),
      title: "",
      colors: {}
    };
  },
  created() {
    Bus.$on("alterScore", this.alterScore);
    this.colors = JSON.parse(localStorage.getItem("colors"));
    this.title = localStorage.getItem("workspaceTitle");
    let gameSetId = localStorage.getItem("gameSetId");
    let self = this;
    if (!self.$route.name == "Rules")
      this.$http
        .get(
          `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets/${gameSetId}`
        )
        .then(response =>
          self.$store.commit("setScoreState", response.body.score)
        );
  },
  methods: {
    alterScore() {
      this.score = this.$store.getters.getGameData("currentScore");
    },
    defineLastSolo(soloGames) {
      if (soloGames.length < 2) return soloGames[0];
      let lastSolo = soloGames.reduce((a, b) => {
        return a.createdAt > b.createdAt ? a : b;
      });
      return lastSolo;
    }
  }
};
</script>

<style lang="scss">
.navbar {
  // position: fixed;
  max-width: 900px;
  width: 100%;
  .navbar_content {
    // height: 5vh;
    min-height: 55px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding: 0 1rem;

    .logo-container {
      display: flex;
      align-items: center;

      .menu_toggler {
        width: 32px;
        margin-right: 10%;

        &:hover {
          cursor: pointer;
        }

        span {
          width: 32px;
          background-color: #000;
          height: 4px;
          display: flex;
          border-radius: 1px;

          &:nth-child(2) {
            margin: 5px 0;
          }
        }
      }

      .logo {
        img {
          max-width: 70px;
          margin-top: 5px;
          height: 30px;
        }
      }
    }
    .help-container{
      align-items: end;
      text-align: right;
      margin-left: auto;

      .help-content{
        display: flex;
        align-items: end;
        text-decoration: none;
  
        &:hover{
          cursor: pointer;
        }
  
        span{
          border: 1px solid;
          border-radius: 40px;
          padding: 3px 19px;
          font-weight: 900;
          text-transform: uppercase;
        }
      }      
    }
    .score-container {
      //width: 75%;
      display: flex;
      margin-left: 1.5rem;


      .score {
        // width: 120px;
        display: inline-flex;
        // justify-content: flex-end;
        align-items: center;
        font-weight: 900;
        font-size: 17px;

        .score_img {
          width: 0;

          svg {
            position: relative;
            left: -15px;
            // bottom: -3px;
            width: 35px;
          }
        }
        .score_value{
            // width: 65%;
            min-width: 40px;
            background-color: #fff;
            // display: flex;
            // justify-content: flex-end;
            // align-items: center;
            // height: 28px;
            padding-right: 10px;
            padding-left: 25px;
            border-radius: 22px 22px 22px 22px;

            span{

                font-size: 15px;
            }
        }
      }
    }
  }
}

@media only screen and(min-height:850px) {
  .navbar {
    .navbar_content {
      .logo-container {
        .menu_toggler {
          margin-right: 5%;

          span {
            height: 5px;
          }

          span:nth-child(2) {
            margin: 5px 0;
          }
        }

        .logo {
          svg {
            max-width: 90px;
          }
        }
      }

      .score-container {
        .score {
          // width: 130px;

          .score_img {
            svg {
              width: 40px;
            }
          }

          .score_value {
            // height: 35px;
            // padding-right: 15px;
            // width: 100%;
            padding-left: 30px;
            span {
              font-size: 17px;
            }
          }
        }
      }
    }
  }
}
</style>
